import { gql } from '@apollo/client'

// Create Admin User
export const CREATE_ADMIN_USER = gql`
    mutation CreateAdminUser(
        $userRoles: [String!]!
        $additionalInfo: AdminUserAdditionalInfoInput!
        $user: UserInput!
    ) {
        createAdminUser(user_roles: $userRoles, additional_info: $additionalInfo, user: $user) {
            code
            success
            message
        }
    }
`

// Update User Status
export const UPDATE_USER_STATUS = gql`
    mutation UpdateUserStatus($userPool: USER_POOL!, $userId: NonEmptyString!, $enabled: Boolean!, $remarks: String) {
        updateUserStatus(user_pool: $userPool, user_id: $userId, enabled: $enabled, remarks: $remarks) {
            code
            success
            message
        }
    }
`

// Update Admin User
export const UPDATE_ADMIN_USER = gql`
    mutation UpdateAdminUser(
        $userId: NonEmptyString!
        $userRoles: [String!]!
        $userInfo: AdminUserInfoInput!
        $additionalInfo: AdminUserAdditionalInfoInput!
    ) {
        updateAdminUser(user_id: $userId, user_roles: $userRoles, user_info: $userInfo, additional_info: $additionalInfo) {
            code
            success
            message
        }
    }
`
